import React, { useEffect, useState, useCallback } from 'react';
import { fetchOrders, deleteOrder } from '../services/api';

export default function OrderManagement() {
    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const limit = 10;

    const loadOrders = useCallback(() => {
        setLoading(true);
        setError(null);
        fetchOrders(page, limit)
            .then(res => {
                setOrders(res.data.orders);
                setTotalPages(res.data.totalPages);
            })
            .catch(err => {
                setError('Failed to load orders.');
                console.error(err);
            })
            .finally(() => setLoading(false));
    }, [page]);

    useEffect(() => {
        loadOrders();
    }, [loadOrders]);

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this order?')) {
            deleteOrder(id)
                .then(() => loadOrders())
                .catch(err => {
                    setError('Failed to delete the order.');
                    console.error(err);
                });
        }
    };

    return (
        <section className="order-management">
            <h2>Order Management</h2>

            {loading && <p>Loading orders...</p>}

            {error && <p style={{ color: 'red' }}>{error}</p>}

            {!loading && orders.length === 0 && <p>No orders found.</p>}

            {!loading && orders.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Amount</th>
                            <th>Payment Method</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map(order => (
                            <tr key={order._id}>
                                <td>{order._id}</td>
                                <td>
                                    {new Intl.NumberFormat('de-DE', {
                                        style: 'currency',
                                        currency: 'EUR',
                                    }).format(order.amount)}
                                </td>
                                <td>{order.paymentMethod}</td>
                                <td>{order.status || 'N/A'}</td>
                                <td>{new Date(order.date).toLocaleDateString('de-DE')}</td>
                                <td>
                                    <button onClick={() => handleDelete(order._id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <div className="pagination" style={{ marginTop: '15px' }}>
                <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Previous</button>
                <span style={{ margin: '0 10px' }}>Page {page} of {totalPages}</span>
                <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Next</button>
            </div>
        </section>
    );
}
